import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "step1",
    "step2",
    "step3Paste",
    "step3Code",
    "dot1",
    "dot2",
    "dot3",
    "connector1",
    "connector2",
    "manualTab",
    "uploadTab",
    "manualPanel",
    "uploadPanel",
  ];

  static values = { initialStep: Number };

  connect() {
    this.setProgress(this.initialStepValue || 1);
  }

  selectManualRostering() {
    this.hide(this.step2Target);
    this.show(this.step3PasteTarget);
    this.setProgress(3);
  }

  selectStudentJoinCode() {
    this.hide(this.step2Target);
    this.show(this.step3CodeTarget);
    this.setProgress(3);
  }

  switchToManual() {
    this.show(this.manualPanelTarget);
    this.hide(this.uploadPanelTarget);
    this.manualTabTarget.classList.add("bg-violet-700", "text-white");
    this.manualTabTarget.classList.remove("text-violet-700");
    this.uploadTabTarget.classList.remove("bg-violet-700", "text-white");
    this.uploadTabTarget.classList.add("text-violet-700");
  }

  switchToUpload() {
    this.hide(this.manualPanelTarget);
    this.show(this.uploadPanelTarget);
    this.uploadTabTarget.classList.add("bg-violet-700", "text-white");
    this.uploadTabTarget.classList.remove("text-violet-700");
    this.manualTabTarget.classList.remove("bg-violet-700", "text-white");
    this.manualTabTarget.classList.add("text-violet-700");
  }

  setProgress(step) {
    const dots = [this.dot1Target, this.dot2Target, this.dot3Target];
    const connectors = [this.connector1Target, this.connector2Target];

    dots.forEach((dot, i) => {
      const n = i + 1;
      if (n < step) {
        dot.dataset.progressDot = "completed";
      } else if (n === step) {
        dot.dataset.progressDot = "current";
      } else {
        dot.dataset.progressDot = "upcoming";
      }
    });

    connectors.forEach((line, i) => {
      line.dataset.progressConnector = i + 1 < step ? "completed" : "pending";
    });
  }

  show(el) {
    el.classList.remove("hidden");
  }

  hide(el) {
    el.classList.add("hidden");
  }
}
